import { render, staticRenderFns } from "./SlideFormPicMovement.vue?vue&type=template&id=2bbd6fd8"
import script from "./SlideFormPicMovement.vue?vue&type=script&lang=js"
export * from "./SlideFormPicMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports